import React from 'react';

import Select from '@atlaskit/select';

import { srOnlyStyles } from 'src/components/accessibility';

const SelectField = (
  props: React.ComponentProps<typeof Select>
): JSX.Element => {
  return (
    <>
      <label className={srOnlyStyles} htmlFor={props.inputId}>
        {props.placeholder}
      </label>
      <Select {...props}></Select>
    </>
  );
};

export default SelectField;
